export default __webpack_public_path__ + "e30170fd9ee1579747e5b576826cc9e3.png";